import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'
import type { Document } from '@contentful/rich-text-types'
import { BLOCKS } from '@contentful/rich-text-types'

import Image from '@segment/matcha/components/Image'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import RichText from '@segment/matcha/recipes/RichText'

import createYourDynamicDataPng2x from './assets/CreateYourDynamicData@2x.png'
import createYourDynamicDataWebp from './assets/CreateYourDynamicData.webp'
import createYourDynamicDataWebp2x from './assets/CreateYourDynamicData@2x.webp'
import createYourDynamicDataWebp3x from './assets/CreateYourDynamicData@3x.webp'

const copy = {
  overline: `Customer Data Discovery`,
  heading: `Create your dynamic data inventory in minutes`,
}

const description = {
  content: [
    {
      content: [
        {
          data: {},
          marks: [],
          nodeType: `text`,
          value: `Say goodbye to manual surveys and outdated inventories. With Segment, you can automatically detect and classify personally identifiable information (PII) to create a dynamic customer data inventory for your Segment data.`,
        },
      ],
      data: {},
      nodeType: BLOCKS.PARAGRAPH,
    },
    {
      content: [
        {
          data: {},
          marks: [],
          nodeType: `text`,
          value: `Each data point is matched against common PII fields and assigned a risk-based classification of red, yellow, or green.`,
        },
      ],
      data: {},
      nodeType: BLOCKS.PARAGRAPH,
    },
  ],
  data: {},
  nodeType: BLOCKS.DOCUMENT,
} as Document

const CreateYourDynamicData: FC<PropsWithChildren<unknown>> = () => {
  return (
    <SectionBase variant="2Col" copyVariant="narrow" reverse={true}>
      <Section.Copy>
        <CopyTextBase>
          <CopyText.Overline>{copy.overline}</CopyText.Overline>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <RichText data={description} />
        </CopyTextBase>
      </Section.Copy>
      <SectionContents>
        <picture>
          <source
            type="image/webp"
            srcSet={`${createYourDynamicDataWebp}, ${createYourDynamicDataWebp2x} 2x, ${createYourDynamicDataWebp3x} 3x`}
          />
          <Image
            width="640"
            height="600"
            src={createYourDynamicDataPng2x}
            alt="Illustration: Create your dynamic data"
            loading="lazy"
          />
        </picture>
      </SectionContents>
    </SectionBase>
  )
}

const SectionContents = styled(Section.Contents)`
  justify-content: center;
  align-self: center;
  display: flex;
`

export default CreateYourDynamicData
